import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  SETUP_GOCARDLESS_TABS,
  fetchGoCardlessTenantsForBooking,
  fetchSuggestedGoCardlessCustomersAndInvitations
} from 'ducks/tenancy';

import {
  Navigation,
  Suggested,
  SendInvitation,
  GoCardlessSearchForm
} from './components';

import './styles.css';

class SetupGocardlessModal extends React.Component<any> {
  state = {
    selectedTab: SETUP_GOCARDLESS_TABS.SUGGESTED
  };

  componentDidMount() {
    // This information is not fetched in the separate sections,
    // because every time we change the sections tabs, we would make calls.
    this.fetchGoCardlessTenantsForBooking();
    this.fetchSuggestedGoCardlessCustomersAndInvitations();
  }

  selectTabHandler = (selectedTab: string) => {
    this.setState({selectedTab});
  };

  getSelectedTab = () => {
    const {selectedTab} = this.state;
    const suggested = selectedTab === SETUP_GOCARDLESS_TABS.SUGGESTED;
    const search = selectedTab === SETUP_GOCARDLESS_TABS.SEARCH_GOCARDLESS;
    const sendInvitation =
      selectedTab === SETUP_GOCARDLESS_TABS.SEND_INVITATION;

    return {suggested, search, sendInvitation};
  };

  fetchGoCardlessTenantsForBooking = () => {
    const {data: {bookingId}} = this.props;
    const extraActions = this.props.storeDataExtraActions(data => ({
      tenantsPerBooking: data
    }));

    this.props.fetchGoCardlessTenantsForBooking({bookingId}, extraActions);
  };

  fetchSuggestedGoCardlessCustomersAndInvitations = () => {
    const {data: {tenancyId}} = this.props;
    const extraActions = this.props.storeDataExtraActions(data => ({
      suggestedCustomers: data.gocardlessCustomers,
      suggestedInvitations: data.gocardlessInvitations
    }));

    this.props.fetchSuggestedGoCardlessCustomersAndInvitations(
      {tenancyId},
      extraActions
    );
  };

  render() {
    const {selectedTab} = this.state;

    const {
      data: {
        tenantsPerBooking,
        tenancyId,
        suggestedCustomers,
        suggestedInvitations
      }
    } = this.props;

    const {suggested, search, sendInvitation} = this.getSelectedTab();

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="SetupGocardlessModal"
        type={Modal.MEDIUM}>
        <Modal.Header>
          <h3 className="colab-heading">Setup GoCardless for Booking</h3>
        </Modal.Header>
        <Modal.Body>
          <Navigation
            selectedTab={selectedTab}
            selectTab={this.selectTabHandler}
          />
          {suggested && (
            <Suggested
              tenancyId={tenancyId}
              customers={suggestedCustomers}
              invitations={suggestedInvitations}
            />
          )}
          {search && <GoCardlessSearchForm tenancyId={tenancyId} />}
          {sendInvitation &&
            tenantsPerBooking && (
              <SendInvitation
                tenantsPerBooking={tenantsPerBooking}
                openSendGoCardlessInvitationWarningsModal={
                  this.props.openSendGoCardlessInvitationWarningsModal
                }
              />
            )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToModalData = (_state, data) => ({
  tenantsPerBooking: _.get(data, 'tenantsPerBooking', []),
  suggestedCustomers: _.get(data, 'suggestedCustomers', []),
  suggestedInvitations: _.get(data, 'suggestedInvitations', [])
});

const mapDispatchToModalProps = {
  fetchGoCardlessTenantsForBooking,
  fetchSuggestedGoCardlessCustomersAndInvitations
};

export default withModal(
  MODALS.SETUP_GOCARDLESS,
  mapStateToModalData,
  mapDispatchToModalProps
)(SetupGocardlessModal);
